module.exports = __webpack_public_path__ + "static/media/loan.f1f0e5a3.png";